import pluginConfig from './config'

class TrackingBase {
  /**
   * @param {string} id
   * @param {object} config
   */
  constructor (id, config) {
    this.settings = {
      ...pluginConfig,
      ...config
    }

    this.id = id
    this.env = process.env.VUE_APP_ENVIRONMENT

    if (this.isEnabled()) {
      this.enable()
    }
  }

  /**
   * @param {string} message
   * @param {...*}   otherArguments
   */
  log (message, ...otherArguments) {
    if (this.settings.isDebugEnabled) {
      console.warn(`Tracker [${this.id}]:`, message, ...otherArguments)
    }
  }

  /**
   * @returns {boolean}
   */
  isEnabled () {
    return Boolean(this.settings.isEnabled && this.id)
  }

  /**
   */
  enable () {
    this.log('Enabling script', { id: this.id, env: this.env })
    this.loadScript()

    this.settings.isEnabled = true
  }

  /**
   */
  getAnalytics () {}

  /**
   */
  loadScript () {}

  /**
   * @param {string | null} [payload={}]
   * @param {string | null} [payload.object]
   * @param {string | null} [payload.event='event-custom']
   * @param {string | null} [payload.category=null]
   * @param {string | null} [payload.action=null]
   * @param {string | null} [payload.label=null]
   * @param {string | null} [payload.value=null]
   * @param {string | null} [payload.item=null]
   * @param {...*}          [payload.rest]
   */
  trackEvent ({
    event = 'eventCustom',
    object,
    action = null,
    category = null,
    label = null,
    value = null,
    item = null,
    ...rest
  } = {}) {
    if (this.isEnabled()) {
      this.log('Dispatching event', {
        event,
        object,
        action,
        category,
        label,
        value,
        item,
        ...rest
      })
    }
  }

  /**
   * @param {string | number} userIdentifier
   * @param {object}          user
   * @param {string}          platform
   */
  identifyUser (userIdentifier, user, platform) {
    if (this.isEnabled()) {
      this.log('Identifying user', {
        userIdentifier,
        user,
        platform,
        env: this.env
      })
    }
  }
}

export default TrackingBase
